import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlService } from 'src/app/shared/services/url.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageRequestsService {
  itemsPerPage = 10;
  p: number = 1;
  constructor(private http: HttpClient,private apiUrlService: ApiUrlService) { }
  
  apiUrl = this.apiUrlService.getApiUrl();
  getAllStatus(statusTypeId: number) {
    return this.http.post(`${this.apiUrl}/v1/getAllStatuses`, { statusTypeId });
  }
 onAccessRequestDetailsFilter(filterValues: any,itemsPerPage:any,page:any) {
      return this.http.post(
        `${environment.apiUrl2}/v1/accessRequests?limit=${itemsPerPage}&page=${page}`,
        filterValues
      );
  }
  onAccessRequestList(filterValues: any) {
      return this.http.post(
        `${environment.apiUrl2}/v1/accessRequests`,
        filterValues
      );
  }  
  getAccessRequestDetails(accessRequestId: any) {
      const userId: any = localStorage.getItem('userId');
      let headers = new HttpHeaders()
        .append('userId', userId.toString())
        .append('accessRequestId', accessRequestId.toString());
      const requestOptions = { headers: headers };
      return this.http.post(
        `${this.apiUrl}/v1/accessRequestDetails`,
        null,
        requestOptions
      );
    }
  getAccessRequestSubscriptionsDetails(accessRequestId: any) {
        const userId: any = localStorage.getItem('userId');
         let payload = {
            userId: userId, 
            accessRequestId:accessRequestId.toString() 
        }
        return this.http.post(
          `${this.apiUrl}/v1/accessRequestSubscriptions`,
          payload
        );
    }
    getBusinessProductLines(headerId: any) {
      let headers = new HttpHeaders().append('moduleId', headerId.toString());
      const requestOptions = { headers: headers };
      return this.http.post(
        `${environment.apiUrl}/v1/businessProductLines`,
        null,
        requestOptions
      );
    }

    getRegionsByBusinessProductLines(headerId: any,payload:any) {
      let headers = new HttpHeaders().append('moduleId', headerId.toString());
      const requestOptions = { headers: headers };
      return this.http.post(
        `${environment.apiUrl}/v1/regionsByBusinessProductLines`,
        payload,
        requestOptions
      );
    }
    createAccessRequest(payload:any) {
       return this.http.post(
        `${environment.apiUrl2}/v1/createAccessRequest`,
        payload
      );
    }

     accessRequestAction(payload:any) {
       return this.http.post(
        `${environment.apiUrl2}/v1/accessRequestAction`,
        payload
      );
    }

    getDataForSteps(moduleId: any) {
       let headers = new HttpHeaders().append('moduleId', moduleId.toString());
        const requestOptions = { headers: headers };
        return this.http.post(
          `${environment.apiUrl}/v1/flowStepDetails`,
          null,
          requestOptions
        );
    }
    getDataByEndpoint(moduleId: any,endPoint:any,payload:any) {
       let headers = new HttpHeaders().append('moduleId', moduleId.toString());
        const requestOptions = { headers: headers };
        return this.http.post(
          `${environment.apiUrl}/v1/${endPoint}`,
          payload,
          requestOptions
        );
    }
}
